import { render, staticRenderFns } from "./BulletinDetail.vue?vue&type=template&id=20d03049"
import script from "./BulletinDetail.vue?vue&type=script&lang=js"
export * from "./BulletinDetail.vue?vue&type=script&lang=js"
import style0 from "./BulletinDetail.vue?vue&type=style&index=0&id=20d03049&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports